import React, { createContext, useContext, useState, useEffect } from "react";
import { updateLanguage } from "../../api/userLanguage";

const TranslationContext = createContext();

export const TranslationProvider = ({ children, user }) => {
  const [language, setLanguage] = useState(
    user?.language ||
      (navigator.language.startsWith("cs")
        ? "cs"
        : navigator.language.startsWith("de")
        ? "de"
        : navigator.language.startsWith("fr")
        ? "fr"
        : navigator.language.startsWith("es")
        ? "es"
        : navigator.language.startsWith("pt")
        ? "pt"
        : navigator.language.startsWith("it")
        ? "it"
        : navigator.language.startsWith("pl")
        ? "pl"
        : "en")
  );

  const [dictionary, setDictionary] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const dict = await import(`./Languages/${language}.js`);
        setDictionary(dict.default || dict);
      } catch (err) {
        const fallback = await import("./Languages/en.js");
        setDictionary(fallback.default || fallback);
      }
    })();
  }, [language]);

  useEffect(() => {
    if (user?.user_id && language && language !== user.language) {
      updateLanguage(user.user_id, language).catch(() => {});
    }
  }, [language, user]);

  const translate = (key) => dictionary[key] || key;

  return (
    <TranslationContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslate = () => useContext(TranslationContext);
